export const domain = 'https://api.fasdo.in/api/';
export const appLinkPlayStore = 'https://play.google.com/store/apps/details?id=com.dev.doorstep';

// add +5:30 to UTC time
export const utcHours = 5
export const utcMins = 30

export const ContentType = 'application/json'
export const AccessControlAllowOrigin = '*'
export const XRequestedWith = 'XMLHttpRequest'
export const thresholdShippingCost = 299


// WEBPACK FOOTER //
// ./src/store/variable.js